
import { styled } from '@mui/material/styles';
import { Box, Typography, Paper } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
  margin: '0 auto',
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '1.5rem',
  marginBottom: theme.spacing(3),
  color: theme.palette.text.primary,
}));

export const NotificationCard = styled(Paper)<{ statusColor: string; isRead: boolean }>(({ theme, statusColor, isRead }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2.5),
  marginBottom: theme.spacing(2),
  borderRadius: '8px',
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: isRead ? theme.palette.common.white : '#f0f7ff', // Light blue for unread

  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '6px',
    backgroundColor: statusColor,
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline',
  marginBottom: theme.spacing(0.5),
}));

export const NotificationTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1rem',
  color: theme.palette.text.primary,
}));

export const NotificationTime = styled(Typography)(({ theme }) => ({
  fontSize: '0.85rem',
  color: theme.palette.grey[500],
  fontStyle: 'italic',
}));

export const NotificationBody = styled(Typography)(({ theme }) => ({
  fontSize: '0.95rem',
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(1),
  lineHeight: 1.5,
}));

export const NotificationFooter = styled(Typography)(({ theme }) => ({
  fontSize: '0.9rem',
  color: theme.palette.grey[600],
  fontWeight: 500,
}));
